module.exports = {
  NgProbeToken: {},
  _createConditionalRootRenderer: function(rootRenderer, extraTokens, coreTokens) {
    return rootRenderer; 
  },
  __platform_browser_private__: {} 
};  
  


//////////////////
// WEBPACK FOOTER
// ./~/@angular/core/src/debug/debug_renderer.js
// module id = 372
// module chunks = 0